export default __webpack_public_path__ + "static/media/on-3.348264bf.png";